export default "__VITE_ASSET__8158efe8__"